import Footer from '../base/footer';
import returnToTop from '../base/returnToTop';
import baidu from '../base/baidu';
import { registerProductPage } from '../base/product2026';

registerProductPage('CineON', 22);
